var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _ellipse, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1142,
    height: 850,
    viewBox: "0 0 1142 850",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.64026,
    height: 692.442,
    transform: "matrix(-1 0 0 1 503.968 86.0068)",
    fill: "#584843",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.84898,
    height: 614.278,
    transform: "matrix(-0.0026873 -0.999996 -0.999994 0.00341471 1077.44 136.546)",
    fill: "#584843",
    fillOpacity: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1.64026,
    height: 692.442,
    transform: "matrix(-1 0 0 1 571.219 86.0068)",
    fill: "#584843",
    fillOpacity: 0.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1.84898,
    height: 614.278,
    transform: "matrix(-0.0026873 -0.999996 -0.999994 0.00341471 1077.65 212.353)",
    fill: "#584843",
    fillOpacity: 0.2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1.64026,
    height: 692.442,
    transform: "matrix(-1 0 0 1 638.469 86.0068)",
    fill: "#584843",
    fillOpacity: 0.2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 1.84898,
    height: 614.278,
    transform: "matrix(-0.0026873 -0.999996 -0.999994 0.00341471 1077.85 288.161)",
    fill: "#584843",
    fillOpacity: 0.2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 1.64026,
    height: 692.442,
    transform: "matrix(-1 0 0 1 705.72 86.0068)",
    fill: "#584843",
    fillOpacity: 0.2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 1.84898,
    height: 614.278,
    transform: "matrix(-0.0026873 -0.999996 -0.999994 0.00341471 1078.06 363.969)",
    fill: "#584843",
    fillOpacity: 0.2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 1.64026,
    height: 692.442,
    transform: "matrix(-1 0 0 1 772.971 86.0068)",
    fill: "#584843",
    fillOpacity: 0.2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 1.84898,
    height: 614.278,
    transform: "matrix(-0.0026873 -0.999996 -0.999994 0.00341471 1078.26 439.776)",
    fill: "#584843",
    fillOpacity: 0.2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 1.64026,
    height: 692.442,
    transform: "matrix(-1 0 0 1 840.221 86.0068)",
    fill: "#584843",
    fillOpacity: 0.2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 1.84898,
    height: 614.278,
    transform: "matrix(-0.0026873 -0.999996 -0.999994 0.00341471 1078.46 515.584)",
    fill: "#584843",
    fillOpacity: 0.2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 1.64026,
    height: 692.442,
    transform: "matrix(-1 0 0 1 907.472 86.0068)",
    fill: "#584843",
    fillOpacity: 0.2
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 1.84898,
    height: 614.278,
    transform: "matrix(-0.0026873 -0.999996 -0.999994 0.00341471 1078.67 591.391)",
    fill: "#584843",
    fillOpacity: 0.2
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 1.64026,
    height: 692.442,
    transform: "matrix(-1 0 0 1 974.722 86.0068)",
    fill: "#584843",
    fillOpacity: 0.2
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 1.84898,
    height: 614.278,
    transform: "matrix(-0.0026873 -0.999996 -0.999994 0.00341471 1078.87 667.199)",
    fill: "#584843",
    fillOpacity: 0.2
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 1.64026,
    height: 692.442,
    transform: "matrix(-1 0 0 1 1041.97 86.0068)",
    fill: "#584843",
    fillOpacity: 0.2
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 1.84898,
    height: 614.278,
    transform: "matrix(-0.0026873 -0.999996 -0.999994 0.00341471 1079.07 743.007)",
    fill: "#584843",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1,
    filter: "url(#filter0_f_63_148)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 676,
    cy: 385,
    rx: 466,
    ry: 425,
    fill: "#F0741A",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_63_148",
    x: 0.10791,
    y: -249.892,
    width: 1351.78,
    height: 1269.78,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 104.946,
    result: "effect1_foregroundBlur_63_148"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2);
export default __webpack_public_path__ + "static/media/vector2.292447c20bfa754b16dc9af08a25bb42.svg";
export { ForwardRef as ReactComponent };